import { Dialog, DialogContent, DialogOverlay, DialogPortal } from '@radix-ui/react-dialog'
import React, { FC } from 'react'
import styled from 'styled-components'

interface ModalContainerProps {
  open: boolean
  children?: React.ReactNode
}

const ModalContainer: FC<ModalContainerProps> = (props) => {
  const { open, children } = props
  return (
    <Dialog open={open}>
      <Content>{children}</Content>
    </Dialog>
  )
}

const StyledOverlay = styled(DialogOverlay)`
  background-color: black;
  position: fixed;
  inset: 0;
  z-index: 4;
  opacity: 0.2;
`

const StyledContent = styled(DialogContent)`
  z-index: 998;
  background-color: white;
  border-radius: 0.8em;
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: fit-content;
  max-width: 100%;
`

interface ContentProps {
  children?: React.ReactNode
}

const Content: React.FunctionComponent<ContentProps> = (props) => {
  const { children } = props
  return (
    <DialogPortal>
      <Wrapper>
        <StyledOverlay />
        <StyledContent>{children}</StyledContent>
      </Wrapper>
    </DialogPortal>
  )
}

const Wrapper = styled.div`
  z-index: 999;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default ModalContainer
